export function minDate(dateList) {
  if (dateList.length === 0) {
    return null;
  }
  const minTimestamp = Math.min(...dateList.map((date) => date.getTime()));
  return new Date(minTimestamp);
}

export function maxDate(dateList) {
  if (dateList.length === 0) {
    return null;
  }
  const maxTimestamp = Math.max(...dateList.map((date) => date.getTime()));
  return new Date(maxTimestamp);
}

export function generateHourlyDatetimes(startTime, endTime) {
  const datetimes = [];
  // Start the loop with the initial start time
  let currentTime = new Date(startTime);

  // Continue as long as the current time is less than or equal to the end time
  while (currentTime <= endTime) {
    // Push a *copy* of the current time into the array.
    // If you push currentTime directly, all entries in the array
    // would reference the final time after the loop finishes.
    datetimes.push(new Date(currentTime));

    // Add 1 hour to the current time for the next iteration
    // The setHours() method handles rollover (e.g., 23:00 to 00:00 the next day)
    currentTime.setHours(currentTime.getHours() + 1);
  }

  return datetimes;
}

export function hourDiff(date1, date2) {
  // Get the difference in milliseconds
  const diffInMs = date2.getTime() - date1.getTime();

  // Convert milliseconds to hours (1 hour = 3600000 ms)
  const diffInHours = diffInMs / (1000 * 60 * 60);

  return diffInHours;
}
